import { useRef } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { ArrowLeft, ExternalLink, RefreshCw } from "lucide-react";

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

// Point 21: generic in-app webview. Opens a URL (e.g. a home-banner offer link)
// INSIDE the app — TransAsia pages are routed through our first-party proxy so
// they render correctly inside the iframe, just like the News & Events screen.
export default function WebViewPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const iframeRef = useRef(null);

  const rawUrl = params.get("url") || "";
  const title = params.get("title") || "TransAsia";

  let host = "";
  try { host = new URL(rawUrl).hostname.toLowerCase(); } catch { /* ignore */ }
  const isTransAsia = host === "transasia.co.in" || host.endsWith(".transasia.co.in");
  const src = rawUrl
    ? (isTransAsia ? `${BACKEND}/api/insights/proxy?url=${encodeURIComponent(rawUrl)}` : rawUrl)
    : "about:blank";

  const refresh = () => { if (iframeRef.current) iframeRef.current.src = src; };

  return (
    <div className="flex flex-col h-[calc(100vh-9rem)]" data-testid="webview-page">
      <div className="flex items-center justify-between mb-3">
        <button onClick={() => navigate(-1)} className="flex items-center gap-1.5 text-gray-600 hover:text-gray-900 text-sm font-medium" data-testid="webview-back-btn">
          <ArrowLeft className="w-4 h-4" /> Back
        </button>
        <h1 className="text-base font-bold text-gray-900 truncate max-w-[50%]">{title}</h1>
        <div className="flex items-center gap-1">
          <button onClick={refresh} className="p-2 rounded-lg text-gray-500 hover:bg-gray-100" title="Refresh" data-testid="webview-refresh-btn">
            <RefreshCw className="w-4 h-4" />
          </button>
          <a href={rawUrl} target="_blank" rel="noopener noreferrer" className="p-2 rounded-lg text-gray-500 hover:bg-gray-100" title="Open in browser" data-testid="webview-external-btn">
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
      <div className="flex-1 rounded-2xl overflow-hidden border border-slate-200 bg-white shadow-sm">
        <iframe
          ref={iframeRef}
          src={src}
          title={title}
          className="w-full h-full"
          loading="lazy"
          sandbox="allow-same-origin allow-scripts allow-popups allow-forms allow-top-navigation-by-user-activation"
          data-testid="webview-iframe"
        />
      </div>
    </div>
  );
}
